import PortainerConnectionsStore from "./PortainerConnections/PortainerConnectionsStore";
import RegistryConnectionsStore from "./RegistryConnections/RegistryConnectionsStore";
import RegistryImagesStore from "./RegistryImages/RegistryImagesStore";
import DockerHostsStore from "./DockerHosts/DockerHostsStore";
import ClientInstancesStore from "./ClientInstances/ClientInstancesStore";
import InternalContainersStore from "./InternalContainers/InternalContainersStore";
import InstanceActionsStore from "./InstanceActions/InstanceActionsStore";
import InstanceDetailStore from "./InstanceDetail/InstanceDetailStore";
import InstanceDriftStore from "./DeploymentStatus/InstanceDriftStore";
import InstanceUsersStore from "./InstanceUsers/InstanceUsersStore";
import InstanceEnvStore from "./InstanceEnv/InstanceEnvStore";

const infrastructureStoreList = [
  // Writable registry of Portainer servers (base URL + write-only API key).
  { name: "portainerConnectionsViewStore", store: PortainerConnectionsStore },
  // Writable registry of Azure Container Registries (login server + auth method
  // + write-only credential). Staff read; admin write/validate (gated in-store).
  { name: "registryConnectionsViewStore", store: RegistryConnectionsStore },
  // Read-only ACR image catalog (repositories + tags via read-through services).
  { name: "registryImagesStore", store: RegistryImagesStore },
  { name: "dockerHostsViewStore", store: DockerHostsStore },
  { name: "clientInstancesViewStore", store: ClientInstancesStore },
  // IntraSync's own containers (operator-designated 'internal') — the fleet
  // view for our infrastructure, separate from the client groupings.
  { name: "internalContainersStore", store: InternalContainersStore },
  // Cross-view store backing the Deploy / Rollback / confirm dialogs + the
  // instance action-audit history (shared by the grid, the ClientDetail tab,
  // and the InstanceDetail view).
  { name: "instanceActionsViewStore", store: InstanceActionsStore },
  // The InstanceDetail console view (live logs / stats / exec + audit).
  { name: "instanceDetailStore", store: InstanceDetailStore },
  // Deployment Status (Deployment Drift & Go-Live Readiness) — name matches
  // what deploymentStatus.Route reads off the rootStore.
  { name: "instanceDriftViewStore", store: InstanceDriftStore },
  // Users on a client's OWN instance (Client 360 → Users tab + its dialogs):
  // connection settings (admin), add/edit/disable/reset (operator), activity.
  { name: "instanceUsersViewStore", store: InstanceUsersStore },
  // The Environment card on the instance console (#3468, admin only): the
  // container's variables (secret values masked), a draft, its review and the
  // apply, which runs through instance-actions `set-env`.
  { name: "instanceEnvViewStore", store: InstanceEnvStore },
];

export default infrastructureStoreList;
